const Ddata = [
    {
       name: "I am a professional Frontend Developer having 3 years of Experience.",
      para: "I'm a excellent Javascript developer, writing Vue,laravel,Html, React for web developments.  My work is to make client's vision and demands comes to a reality, as i enjoy working for both individuals and companies of different sizes. I always come up with solutions to meet their diverse needs. ",
      head: ""
    }
  
  ]
  export default Ddata
  